import Vue from 'vue';
import Router from 'vue-router';
import CreateSpace from '@/components/Pages/saas/CreateSpace.vue';
import SaaSBase from '@/components/Pages/saas/Base.vue';
import AuthCallbackV2 from '@/components/Pages/saas/AuthCallbackV2.vue';
import CreateSpaceSuccess from '@/components/Pages/saas/CreateSpaceSuccess.vue';
import CreateSpaceAfterPayment from '@/components/Pages/saas/CreateSpaceAfterPayment.vue';

Vue.use(Router);
const redirectorToLanding = (to) => {
    window.open('https://coapp.io', '_self');
};

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '',
            component: SaaSBase,
            children: [
                {
                    path: '/create/success/:domain',
                    name: 'CreateSpaceSuccess',
                    component: CreateSpaceSuccess,
                },
                {
                    path: '/create/payment/success',
                    name: 'CreateSpaceAfterPayment',
                    component: CreateSpaceAfterPayment,
                },
                {
                    path: '/create',
                    name: 'Create Community',
                    component: CreateSpace,
                },
                {
                    path: '/oauth2/google/callback',
                    name: 'OAuth2 Callback',
                    component: AuthCallbackV2,
                },
                {
                    path: '/oauth2/token/callback',
                    name: 'Generic OAuth2 Callback',
                    component: AuthCallbackV2,
                },
                {
                    // redirect all unresolved urls to dashboard
                    path: '*',
                    name: 'Redirect',
                    beforeEnter: redirectorToLanding,
                },
            ],
        },
    ],
});
